module.exports = __webpack_public_path__ + "static/choosing-the-right-business-710afddc2d4b9841986ae9a742ac128b.jpg";